window.addEventListener('DOMContentLoaded', function () {
    let splides = document.querySelectorAll('.banner-promo');

    if (splides.length > 0) {
        for (let i = 0; i < splides.length; i++) {
            let splide = splides[i];

            let splide_slider = new Splide(splide, {
                type: 'fade',
                rewind: true,
                arrows: false,
                pagination: true,
                drag: true,
                autoplay: true,
                interval: 5000
            });

            splide_slider.mount();
        }
    }
});
